module.exports = __webpack_public_path__ + "static/media/math.5b6808f3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/games/math.svg
// module id = 1458
// module chunks = 0